// APP
export const GEOLOCATION = 'GEOLOCATION'

// Auth
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
